<script>
import ResourceDetail from '@shell/components/ResourceDetail';

export default {
  name:       'ClusterResourcedId',
  components: { ResourceDetail },
};
</script>

<template>
  <ResourceDetail />
</template>
